import { useLang } from './lang.js';
import { COPY, type Copy } from './copy/index.js';

/**
 * The dictionary for the reader's language.
 *
 * Returns the whole tree rather than a lookup function: `t.shell.nav.sessions`
 * is checked by the compiler, where `t('shell.nav.sessions')` would be a
 * string that silently renders as itself once someone renames a key.
 */
export function useT(): Copy {
  const [lang] = useLang();
  return COPY[lang];
}
